import gql from 'graphql-tag'
import { CUSTOM_AUX_TAG_TEXT_FRAGMENT, FUNNEL_STEP_FRAGMENT } from 'graphql/Agency/AgencyFragments'
import { EXTERNAL_CHAT_CHANNEL_FRAGMENT } from 'graphql/Chats/ExternalChatChannelFragments'

export const USER_AGENCY_FRAGMENT = gql`
fragment UserAgencyFragment on RealEstateAgencyChild {
  id
  name
  parent {
    id
    idsMongo
    realEstateAgenciesDatabases {
      _id
      name
    }
    name
    url
  }
  chatWidgets {
    id
    name
    channel
    externalChatChannels {
      ...ExternalChatChannelFragment
    }
  }
  funnelSteps {
    ...FunnelStepFragment
  }
  crmEnabled
  crmSendMethod
  disabledDealType
  updateFunnelStepCount
  updateCrmFunnelStep
  defaultFunnelStep
  enableSendObservationToClient
  hideOtherSalesmanObservations
  departments {
    id
    name
    tags
  }
  customAuxTagTexts {
    ...CustomAuxTagTextFragment
  }
  tagsToHide
  clientsImporterType
}
${EXTERNAL_CHAT_CHANNEL_FRAGMENT}
${FUNNEL_STEP_FRAGMENT}
${CUSTOM_AUX_TAG_TEXT_FRAGMENT}
`

export const USER_FRAGMENT = gql`

fragment notificationSettingsFragment on NotificationSettings {
  id
  administrativeBuy
  administrativeRent
  administrativeUndefinedDealType
  administrativeBadEvaluation
  angariationBuy
  angariationRent
  angariationUndefinedDealType
  angariationBadEvaluation
  financialBuy
  financialRent
  financialUndefinedDealType
  financialBadEvaluation
  leadsBuy
  leadsRent
  leadsUndefinedDealType
  leadsBadEvaluation
  emailsToNotifyError
  notifyCrmError
  ackThreshold
  clientChangedAgency
  qrCode
}

fragment UserFragment on User {
  id
  email
  phone
  name
  nickname
  role
  clientTagsPermissions

  telegramUser 
  telegramChatId
  telegramNotificationSettings {
    ...notificationSettingsFragment
  }
  whatsappNotificationSettings {
    ...notificationSettingsFragment
  }
  whatsappPhoneNumber
  
  clientsCount
  disabled
  loginsReport {
    count
    firstLogin
    lastLogin
  }
  salesGroupsReport {
    count
    salesGroupsNames
    inactiveSalesGroupsNames
  }

  externalChatChannelsPermissions {
    id
    externalChatChannel {
      id
      name
      disabled
      idInChannel
      type  
    }
  }
  departments {
    id
    name
    tags
  }
  si9Code
  publicApiTokens {
    id
    name
    createdAt
    disabled
    expiresAt
    tokenString
  }
}
`

export const USER_MINIMAL_FRAGMENT = gql`
fragment UserMinimalFragment on User {
  id
  name
  email
  phone
  role
  disabled
}
`

export const USER_WITH_ALL_AGENCIES_FRAGMENT = gql`
fragment UserWithAllAgenciesFragment on User {
  ...UserFragment
  agent {
    agencies {
      ...UserAgencyFragment
    }
    pages
  }
}
${USER_FRAGMENT}
${USER_AGENCY_FRAGMENT}
`

export const USER_WITH_AGENCY_CHILDREN_FRAGMENT = gql`
fragment UserWithAgencyChildrenFragment on User {
  ...UserFragment
  loginsReport {
    count
    firstLogin
    lastLogin
  }
  salesGroupsReport {
    count
    salesGroupsNames
    inactiveSalesGroupsNames
  }
  agent {
    agencies {
      id
      name
    }
  }
}
${USER_FRAGMENT}
`
